import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/promotions/PromotionPageElement.tsx");
